import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class GetLeaderboardDto {
	@IsString()
	@IsNotEmpty()
	eventId: string;

	@IsString()
	@IsNotEmpty()
	lobbyId: string;

	@IsOptional()
	matchIds: string[];

	@IsOptional()
	isOverall: boolean;
}
